module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/school_photo-f1025.png";